import { Pagination as AntdPagination } from 'antd';
import { TEN_PER_PAGE } from '../../utils/const';
import style from './style.module.scss';

/* This component basically just simplifies and constrains the Antd Pagination component */

export interface PaginationProps {
    className?: string;
    page?: number;
    pageSize?: number;
    total?: number;
    onPageChange: (pageNumber: number) => void;
    onPageSizeChange?: (pageSize: number) => void;
}

export const Pagination = ({
    className,
    page,
    pageSize,
    total,
    onPageChange,
    onPageSizeChange,
}: PaginationProps) => {
    return (
        <div className={style.pagination}>
            <AntdPagination
                className={className}
                current={(page ?? 0) + 1}
                pageSize={pageSize ?? TEN_PER_PAGE}
                total={total}
                onChange={(pageNumber) => onPageChange(pageNumber - 1)}
                onShowSizeChange={
                    onPageSizeChange
                        ? (_current, size) => onPageSizeChange(size)
                        : undefined
                }
                showSizeChanger={!!onPageSizeChange}
                showQuickJumper={false}
                pageSizeOptions={['10', '20', '50', '100']}
                showLessItems={true}
                hideOnSinglePage={false}
                locale={{ items_per_page: 'items / page' }}
            />
        </div>
    );
};
